/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {SiteConcession} from '../bioplanModels';
/**
 * PlanningSiteConcessionApi - axios parameter creator
 * @export
 */
export const PlanningSiteConcessionApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Delete concession by its identifier
     * @param {string} concessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteConcessionsConcessionIdDelete: async (
      concessionId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'concessionId' is not null or undefined
      assertParamExists('siteConcessionsConcessionIdDelete', 'concessionId', concessionId);
      const localVarPath = `/siteConcessions/{concessionId}`.replace(
        `{${'concessionId'}}`,
        encodeURIComponent(String(concessionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get concessions for a plan by its identifier
     * @param {string} concessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteConcessionsConcessionIdGet: async (
      concessionId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'concessionId' is not null or undefined
      assertParamExists('siteConcessionsConcessionIdGet', 'concessionId', concessionId);
      const localVarPath = `/siteConcessions/{concessionId}`.replace(
        `{${'concessionId'}}`,
        encodeURIComponent(String(concessionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update concession for a plan
     * @param {string} concessionId
     * @param {SiteConcession} siteConcession
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteConcessionsConcessionIdPut: async (
      concessionId: string,
      siteConcession: SiteConcession,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'concessionId' is not null or undefined
      assertParamExists('siteConcessionsConcessionIdPut', 'concessionId', concessionId);
      // verify required parameter 'siteConcession' is not null or undefined
      assertParamExists('siteConcessionsConcessionIdPut', 'siteConcession', siteConcession);
      const localVarPath = `/siteConcessions/{concessionId}`.replace(
        `{${'concessionId'}}`,
        encodeURIComponent(String(concessionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(siteConcession, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get site concessions
     * @param {string} planId
     * @param {string} [siteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteConcessionsGet: async (
      planId: string,
      siteId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('siteConcessionsGet', 'planId', planId);
      const localVarPath = `/siteConcessions/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      if (siteId !== undefined) {
        localVarQueryParameter['siteId'] = siteId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create concession for a site
     * @param {SiteConcession} siteConcession
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteConcessionsPost: async (
      siteConcession: SiteConcession,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'siteConcession' is not null or undefined
      assertParamExists('siteConcessionsPost', 'siteConcession', siteConcession);
      const localVarPath = `/siteConcessions/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(siteConcession, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningSiteConcessionApi - functional programming interface
 * @export
 */
export const PlanningSiteConcessionApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningSiteConcessionApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Delete concession by its identifier
     * @param {string} concessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async siteConcessionsConcessionIdDelete(
      concessionId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.siteConcessionsConcessionIdDelete(
        concessionId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningSiteConcessionApi.siteConcessionsConcessionIdDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get concessions for a plan by its identifier
     * @param {string} concessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async siteConcessionsConcessionIdGet(
      concessionId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SiteConcession>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.siteConcessionsConcessionIdGet(concessionId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningSiteConcessionApi.siteConcessionsConcessionIdGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update concession for a plan
     * @param {string} concessionId
     * @param {SiteConcession} siteConcession
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async siteConcessionsConcessionIdPut(
      concessionId: string,
      siteConcession: SiteConcession,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SiteConcession>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.siteConcessionsConcessionIdPut(
        concessionId,
        siteConcession,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningSiteConcessionApi.siteConcessionsConcessionIdPut']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get site concessions
     * @param {string} planId
     * @param {string} [siteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async siteConcessionsGet(
      planId: string,
      siteId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SiteConcession>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.siteConcessionsGet(planId, siteId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningSiteConcessionApi.siteConcessionsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create concession for a site
     * @param {SiteConcession} siteConcession
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async siteConcessionsPost(
      siteConcession: SiteConcession,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SiteConcession>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.siteConcessionsPost(siteConcession, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningSiteConcessionApi.siteConcessionsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningSiteConcessionApi - factory interface
 * @export
 */
export const PlanningSiteConcessionApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningSiteConcessionApiFp(configuration);
  return {
    /**
     *
     * @summary Delete concession by its identifier
     * @param {PlanningSiteConcessionApiSiteConcessionsConcessionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteConcessionsConcessionIdDelete(
      requestParameters: PlanningSiteConcessionApiSiteConcessionsConcessionIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .siteConcessionsConcessionIdDelete(requestParameters.concessionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get concessions for a plan by its identifier
     * @param {PlanningSiteConcessionApiSiteConcessionsConcessionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteConcessionsConcessionIdGet(
      requestParameters: PlanningSiteConcessionApiSiteConcessionsConcessionIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SiteConcession> {
      return localVarFp
        .siteConcessionsConcessionIdGet(requestParameters.concessionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update concession for a plan
     * @param {PlanningSiteConcessionApiSiteConcessionsConcessionIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteConcessionsConcessionIdPut(
      requestParameters: PlanningSiteConcessionApiSiteConcessionsConcessionIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SiteConcession> {
      return localVarFp
        .siteConcessionsConcessionIdPut(requestParameters.concessionId, requestParameters.siteConcession, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get site concessions
     * @param {PlanningSiteConcessionApiSiteConcessionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteConcessionsGet(
      requestParameters: PlanningSiteConcessionApiSiteConcessionsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<SiteConcession>> {
      return localVarFp
        .siteConcessionsGet(requestParameters.planId, requestParameters.siteId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create concession for a site
     * @param {PlanningSiteConcessionApiSiteConcessionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    siteConcessionsPost(
      requestParameters: PlanningSiteConcessionApiSiteConcessionsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SiteConcession> {
      return localVarFp
        .siteConcessionsPost(requestParameters.siteConcession, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for siteConcessionsConcessionIdDelete operation in PlanningSiteConcessionApi.
 * @export
 * @interface PlanningSiteConcessionApiSiteConcessionsConcessionIdDeleteRequest
 */
export interface PlanningSiteConcessionApiSiteConcessionsConcessionIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningSiteConcessionApiSiteConcessionsConcessionIdDelete
   */
  readonly concessionId: string;
}

/**
 * Request parameters for siteConcessionsConcessionIdGet operation in PlanningSiteConcessionApi.
 * @export
 * @interface PlanningSiteConcessionApiSiteConcessionsConcessionIdGetRequest
 */
export interface PlanningSiteConcessionApiSiteConcessionsConcessionIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningSiteConcessionApiSiteConcessionsConcessionIdGet
   */
  readonly concessionId: string;
}

/**
 * Request parameters for siteConcessionsConcessionIdPut operation in PlanningSiteConcessionApi.
 * @export
 * @interface PlanningSiteConcessionApiSiteConcessionsConcessionIdPutRequest
 */
export interface PlanningSiteConcessionApiSiteConcessionsConcessionIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningSiteConcessionApiSiteConcessionsConcessionIdPut
   */
  readonly concessionId: string;

  /**
   *
   * @type {SiteConcession}
   * @memberof PlanningSiteConcessionApiSiteConcessionsConcessionIdPut
   */
  readonly siteConcession: SiteConcession;
}

/**
 * Request parameters for siteConcessionsGet operation in PlanningSiteConcessionApi.
 * @export
 * @interface PlanningSiteConcessionApiSiteConcessionsGetRequest
 */
export interface PlanningSiteConcessionApiSiteConcessionsGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningSiteConcessionApiSiteConcessionsGet
   */
  readonly planId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningSiteConcessionApiSiteConcessionsGet
   */
  readonly siteId?: string;
}

/**
 * Request parameters for siteConcessionsPost operation in PlanningSiteConcessionApi.
 * @export
 * @interface PlanningSiteConcessionApiSiteConcessionsPostRequest
 */
export interface PlanningSiteConcessionApiSiteConcessionsPostRequest {
  /**
   *
   * @type {SiteConcession}
   * @memberof PlanningSiteConcessionApiSiteConcessionsPost
   */
  readonly siteConcession: SiteConcession;
}

/**
 * PlanningSiteConcessionApi - object-oriented interface
 * @export
 * @class PlanningSiteConcessionApi
 * @extends {BaseAPI}
 */
export class PlanningSiteConcessionApi extends BaseAPI {
  /**
   *
   * @summary Delete concession by its identifier
   * @param {PlanningSiteConcessionApiSiteConcessionsConcessionIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningSiteConcessionApi
   */
  public siteConcessionsConcessionIdDelete(
    requestParameters: PlanningSiteConcessionApiSiteConcessionsConcessionIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningSiteConcessionApiFp(this.configuration)
      .siteConcessionsConcessionIdDelete(requestParameters.concessionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get concessions for a plan by its identifier
   * @param {PlanningSiteConcessionApiSiteConcessionsConcessionIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningSiteConcessionApi
   */
  public siteConcessionsConcessionIdGet(
    requestParameters: PlanningSiteConcessionApiSiteConcessionsConcessionIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningSiteConcessionApiFp(this.configuration)
      .siteConcessionsConcessionIdGet(requestParameters.concessionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update concession for a plan
   * @param {PlanningSiteConcessionApiSiteConcessionsConcessionIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningSiteConcessionApi
   */
  public siteConcessionsConcessionIdPut(
    requestParameters: PlanningSiteConcessionApiSiteConcessionsConcessionIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningSiteConcessionApiFp(this.configuration)
      .siteConcessionsConcessionIdPut(requestParameters.concessionId, requestParameters.siteConcession, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get site concessions
   * @param {PlanningSiteConcessionApiSiteConcessionsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningSiteConcessionApi
   */
  public siteConcessionsGet(
    requestParameters: PlanningSiteConcessionApiSiteConcessionsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningSiteConcessionApiFp(this.configuration)
      .siteConcessionsGet(requestParameters.planId, requestParameters.siteId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create concession for a site
   * @param {PlanningSiteConcessionApiSiteConcessionsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningSiteConcessionApi
   */
  public siteConcessionsPost(
    requestParameters: PlanningSiteConcessionApiSiteConcessionsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningSiteConcessionApiFp(this.configuration)
      .siteConcessionsPost(requestParameters.siteConcession, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
